import React from 'react';
import { ReactNode, useState } from "react"
import { TAccordionProvided } from "types/Components/Common/Accordion"

type MyProps = {
    children: (provided: TAccordionProvided) => ReactNode
}

/**
 * Accordion layout
 * 
 * ----------------------------------------------------------------
 * example: 
 * <AccordionLayout>
 * {(provided) => (
 * <>
 *     <AccordionHeader {...provided.getHeaderProps()}>
 *         {headerComponent}
 *     </AccordionHeader>
 *
 *     <AccordionBody {...provided.getBodyProps()}>
 *          {bodyComponent}
 *     </AccordionBody> 
 * </>
 * )}
 * </AccordionLayout>
 */
const AccordionLayout = ({children}: MyProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false)

    const provided: TAccordionProvided = {
        getHeaderProps: () => {
            return {
                isOpen: isOpen,
                setIsOpen: setIsOpen
            }
        },

        getBodyProps: () => {
            return {
                isOpen: isOpen
            }
        }
    }

    return (<>{children(provided)}</>)
}

export default AccordionLayout